import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import localforage from "localforage";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CustomTable from "../../../components/CustomTable";
import { filterList } from "../../../libs/utils";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";
import { riskConfigList } from "../../../services/riskConfigurationService";

function RiskConfigurationList({ nbRiskColums, source = "REMITTANCE " }) {
  const [rows, setRows] = useState();
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [isDynamicTable, setIsDynamicTable] = useState(false);

  const setDynamicTable = (parentWidth, tableWidth) => {
    setIsDynamicTable(true);
  };

  const columns = [
    {
      id: "risk_profile",
      label: "Risk Profile",
      minWidth: 20,
      enableSort: true,
    },
    {
      id: "remittance_delay_days",
      label: "Remittance Delay Days",
      minWidth: 35,
      align: "left",
    },
    {
      id: "daily_ach_limit",
      label: "Daily ACH Limit",
      minWidth: 85,
      align: "left",
    },
    {
      id: "monthly_ach_limit",
      label: "Monthly Ach Limit",
      minWidth: 35,
      align: "left",
    },
    {
      id: "yearly_ach_limit",
      label: "Yearly Ach Limit",
      minWidth: 35,
      align: "left",
    },
    {
      id: "daily_ach_out_limit",
      label: "Daily AchOut Limit",
      minWidth: 35,
      align: "left",
    },
    {
      id: "monthly_ach_out_limit",
      label: "Monthly AchOut Limit",
      minWidth: 35,
      align: "left",
    },
    {
      id: "yearly_ach_out_limit",
      label: "Yearly AchOut Limit",
      minWidth: 35,
      align: "left",
    },
    {
      id: "ach_allowed",
      label: "ACH Allowed",
      minWidth: 35,
      align: "left",
    },
    {
      id: "instant_ach_allowed",
      label: "Instant ACH Allowed",
      minWidth: 35,
      align: "left",
    },

    {
      id: "title",
      label: "Title",
      minWidth: 35,
      align: "left",
    },
    {
      id: "description",
      label: "Description",
      minWidth: 45,
      align: "left",
    },
    {
      id: "Action",
      label: "Action",
      minWidth: 100,
      align: "left",
    },
  ];

  const searchData = (e) => {
    setSearchKey(e.target.value);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dataGenerator = (data) => {
    const {
      risk_profile,
      remittance_delay_days,
      banking_delay_days,
      daily_ach_limit,
      monthly_ach_limit,
      yearly_ach_limit,
      daily_ach_out_limit,
      monthly_ach_out_limit,
      yearly_ach_out_limit,
      ach_allowed,
      instant_ach_allowed,
      title,
      description,
      debit_card_daily_cash_limit,
      daily_card_transaction_limit,
      debit_card_allow_foreign_transactions,
      debit_card_allowed,
      ach_out_allowed
    } = data;
    return {
      risk_profile,
      remittance_delay_days,
      banking_delay_days,
      daily_ach_limit,
      monthly_ach_limit,
      yearly_ach_limit,
      daily_ach_out_limit,
      monthly_ach_out_limit,
      yearly_ach_out_limit,
      ach_allowed: ach_allowed?.toString(),
      instant_ach_allowed: instant_ach_allowed?.toString(),
      debit_card_daily_cash_limit,
      daily_card_transaction_limit,
      debit_card_allow_foreign_transactions: debit_card_allow_foreign_transactions?.toString(),
      debit_card_allowed: debit_card_allowed?.toString(),
      ach_out_allowed: ach_out_allowed?.toString(),
      title,
      description,
      Action: (
        <Link
          to={`/app/risk-configuration/${data.risk_profile}?source=${source}`}
          style={{ textDecoration: "none" }}
        >
          <Button variant="contained" size="small" color="warning">
            Edit
          </Button>
        </Link>
      ),
    };
  };

  useEffect(() => {
    setLoading(true);
    localforage.getItem("@riskConfig", (error, data) => {
      if (data) {
        if (data?.length > 0 && typeof data === "object") {
          setRows(data.map((data) => dataGenerator(data)));
        } else {
          setRows([]);
        }
      }
    });
    riskConfigList(source)
      .then((response) => {
        setLoading(false);
        if (response?.length > 0 && typeof response === "object") {
          setRows(response.map((data) => dataGenerator(data)));
        } else {
          setRows([]);
        }
        localforage.setItem("@riskConfig", response, (error, data) => {
          if (error) {
            throw error;
          }
        });
      })
      .catch((error) => {
        setLoading(false);
        throw error;
      });
  }, []);

  return (
    <>
      <Box
        sx={{ px: 6 }}
        className={`main-box ${isDynamicTable ? "dynamicTableStyle" : ""}`}
      >
        <div
          className={`bankAddRuleHeader mb-3 ${
            isDynamicTable ? "listHeaderPaddingRight" : ""
          }`}
        >
          <div
            style={{
              display: "flex",
              padding: "1.5rem 0",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "#33343a" }} variant="h4" component="h4">
              Risk Configuration List
            </Typography>
            {loading && (
              <div
                style={{
                  marginLeft: "12px",
                  color: "#a0a0a0",
                  fontSize: "24px",
                }}
              >
                <i
                  className={`fa fa-refresh ${
                    loading === true ? "fa-spin" : ""
                  }`}
                  aria-hidden="true"
                ></i>
              </div>
            )}
          </div>
          <div style={{ display: "flex", alignItems: "end" }}>
            <TextField
              id="standard-basic"
              label="Search"
              variant="standard"
              sx={{ mr: 1 }}
              onKeyUp={(e) => searchData(e)}
              InputProps={{
                endAdornment: <SearchIcon sx={{ color: "#8a8a8a" }} />,
              }}
            />
            {/* <input
                    onKeyUp={(e) => searchData(e)}
                    type="search"
                    placeholder="Search"
                    className="form-control searchInput"
                  /> */}
            {/* <Link to="/app/merchant/0">
                    <Button size="large" variant="contained" color="primary">
                      Add New Merchant
                    </Button>
                  </Link> */}
            <Tooltip title="Choose Option">
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <MoreVertIcon sx={{ width: 32, height: 32 }} />
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem
                sx={{
                  "&:hover": {
                    background: "#f9da8792",
                    color: "#000",
                  },
                }}
              >
                <Link
                  to={`/app/risk-configuration/0?source=${source}`}
                  style={{ color: "#040721" }}
                >
                  Add Risk Configuration
                </Link>
              </MenuItem>
              {/* <Divider /> */}
              {/* <MenuItem>
                      <ListItemIcon>
                        <PersonAdd fontSize="small" />
                      </ListItemIcon>
                      Add another account
                    </MenuItem> */}
            </Menu>
          </div>
        </div>
        {/* <Box sx={{ pb: 4 }}>
                <TextField id="standard-basic" label="Search" variant="standard" />
              </Box> */}
        <CustomTable
          setDynamicTable={setDynamicTable}
          data={filterList(rows, searchKey) || []}
          columns={source === "BANKING" ? nbRiskColums : columns}
        />
      </Box>
    </>
  );
}

export default RiskConfigurationList;
